import React from 'react';
import SectionTitle from './SectionTitle';
import Toggle from './Toggle';

type Props = {
  accountSummary?: any;
  form: any;
  handleAndTrackLoginFromReturningPatientToggle: (...args: any[]) => any;
  hideLoginLink?: boolean;
  isExistingPatient: any;
  isLoggedIn: boolean;
  initialValues: any;
  location: any;
};

const HaveYouBeenToThisClinicBefore = ({
  accountSummary,
  form,
  handleAndTrackLoginFromReturningPatientToggle,
  hideLoginLink,
  isExistingPatient,
  isLoggedIn,
  initialValues,
  location,
}: Props) => {
  return (
    <div data-testid="have-you-been-to-this-clinic-before">
      <SectionTitle location={location} />

      <Toggle
        accountSummary={accountSummary}
        form={form}
        handleAndTrackLoginFromReturningPatientToggle={
          handleAndTrackLoginFromReturningPatientToggle
        }
        // @ts-expect-error ts-migrate(2322) FIXME: Property 'hideLoginLink' does not exist on type 'I... Remove this comment to see the full error message
        hideLoginLink={hideLoginLink}
        initialValues={initialValues}
        isExistingPatient={isExistingPatient}
        isLoggedIn={isLoggedIn}
        location={location}
      />
    </div>
  );
};

export default HaveYouBeenToThisClinicBefore;
